import axios from 'axios';

import { getPublicSettings } from './SettingsServices';

export const getAllImages = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/images`);
    return data;
};

export const getImageById = async (id) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/images/${id}`);
    return data;
};

export const addImage = async (url) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/images`, {
        url
    });
    return data;
};

export const deleteImage = async (id) => {
    const { data } = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/images/${id}`);
    return data;
};

export const getAllMiniImages = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/minis`);
    return data;
};

export const getMiniImageById = async (id) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/minis/${id}`);
    return data;
};

export const addMiniImage = async (url) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/minis`, {
        url
    });
    return data;
};

export const deleteMiniImage = async (id) => {
    const { data } = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/minis/${id}`);
    return data;
};

// CLOUDINARY: cloud name and unsigned preset come from Admin → Integrations

export const uploadImageToCloudinary = async (image) => {
    const settings = await getPublicSettings();
    const cloudinary = settings.cloudinary;
    if (!cloudinary) throw new Error('Cloudinary is not set up. Add it in Admin → Integrations.');
    const data = new FormData();
    data.append("file", image);
    data.append("upload_preset", cloudinary.uploadPreset);
    const result = await fetch(`https://api.cloudinary.com/v1_1/${cloudinary.cloudName}/image/upload`, {
        method: 'POST',
        body: data
    })
        .then(res => res.json());
    return result;
};
